import { get } from 'lodash';
import { Point3D } from '../../../../team-apis/otterdam/answers/shape-typings';
import { PointCloudContentState } from '../../../state/point-cloud-content-state';

export function getSensorPosition(state: PointCloudContentState): Point3D {
  const { locations, calibrationData } = state;
  const { frameNumber } = state.render;

  const location = get(locations, frameNumber);
  if (location) {
    return location.position;
  }

  // Assuming that the camera position is close to where the sensor should be,
  // and all cameras are close to each other
  for (const calibration of Object.values(calibrationData)) {
    const cameraLocation = get(calibration, [
      'perFrame',
      frameNumber,
      'position',
    ]);
    if (cameraLocation) {
      return cameraLocation;
    }
    const staticLocation = get(calibration, ['static', 'position']);
    if (staticLocation) {
      return staticLocation;
    }
  }

  return [0, 0, 0];
}
